module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABGUlEQVRYR+2XsUrGMBSFc/IIjs66uSm49rRdFN1cnX0Mfx/D1dFRBEFIb6bioKObg4uCb9Ch9ErAFusgEfoTh2QLubn344PACUzihcTzzf8CaNt2o+u6EwD3JF+XtCMiWwAO+r6/ruv6Y+w9GXDOnVprr8YDVd0ry/JpCYimaXYBPE5DgcOiKO7CfgLw3r+p6uYSAyN6vJDc/glwo6rH4+VhGC4iGkWVWGvVGLP6VuxJcgYgIkcALr8sPJPcieoeWSQiD8aYfQDvqnpG8nYGEDbOuZW19pzkWl6HiGgwW1XVZGM2KANkA9lANpANZAPZQFIDyQOJ935tkSyEnRB0fo1kyUNp8lge9CT9mESG28XL1pJ+/0KZHOATqPpFMLPN8u4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/drawtool/DRAWRECT_N.png
// module id = sOz6
// module chunks = 18